import { useCallback, useEffect, useMemo, useRef, useState } from "react";

const useProgramListHook = ({data}) => {

  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  const [totalShow, setTotalShow] = useState(10);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    _processData();
  }, [currentPage, data]);

  const _processData = useCallback(() => {
    const from = currentPage * totalShow - totalShow;
    let to = currentPage * totalShow;
    if (from <= data.length) {
      to = to <= data.length ? to : data.length;
      setCurrentData(data.slice(from, to));
    }
  });

  
  const handlePageChange = useCallback(
    (type) => {
      if (Math.ceil(data.length / totalShow) >= type + 1) {
        setCurrentPage(type + 1);
        _processData();
      }
    },
    [_processData, setCurrentPage, data, totalShow]
  );

  const handleSortOrderChange = useCallback((row, order) => {
    console.log(`handleSortOrderChange key:${row} order: ${order}`);
  }, []);


  return {
    handlePageChange,
    handleSortOrderChange,
    isFetching,
    currentData,
    currentPage,
  }
}

export default useProgramListHook